import { Text, Heading } from "../../components";
import LandingPageWIPFeature from "../../components/LandingPageWIPFeature";
import React, { Suspense } from "react";

const data = [
  {
    image: "images/img_user.svg",
    title: "You share your story",
    description:
      "Start with your imagination. Upload a photo, describe your characters, and tell us what makes this story special to you.",
  },
  {
    image: "images/img_frame_14450.svg",
    title: "We illustrate it for you",
    description:
      "Our smart tools turn your words and images into stunning illustrations, crafted to match your vision.",
  },
  {
    image: "images/img_close.svg",
    title: "Your comic, your way!",
    description:
      "Review your comic, make final tweaks, and it’s ready to WOW! Print it, share it, or keep it as a treasured memory.",
  },
];

export default function LandingpagewipColumn() {
  return (
    <div className="relative mt-[10vw] flex flex-col items-center self-stretch">
      <div className=" flex flex-col px-14 md:px-5">
        <div className=" flex flex-col items-center">
          <Heading size="headingmd" as="h1" className="text-[2.5vw] font-bold md:text-[30px] sm:text-[32px] sm:leading-[40px] sm:text-center">
            How your comic comes to life?
          </Heading>
          <Text as="p" className="md:text-[16px] text-[1vw] font-normal italic sm:text-[16px] sm:text-center sm:mb-[24px]">
            You tell the story, we bring it to life with a touch of AI magic!
          </Text>
        </div>
        <div className="flex gap-8 md:flex-col mt-[2vw]">
          <Suspense fallback={<div>Loading feed...</div>}>
            {data.map((d, index) => (
              <LandingPageWIPFeature {...d} key={"listtitle" + index} />
            ))}
          </Suspense>
        </div>
      </div>
    </div>
  );
}
